import {
  Traces,
  Trace,
  ServiceInstanceOption,
  LogTraces,
  TraceDetailExist,
  TraceInstances, 
  TraceEndpoints
} from '../fragments/trace';

export const queryTraces = `query queryTraces(${Traces.variable}) {${Traces.query}}`;

export const queryTrace = `query queryTrace(${Trace.variable}) {${Trace.query}}`;

export const queryServiceInstance = `query queryServiceInstance(${ServiceInstanceOption.variable})
{${ServiceInstanceOption.query}}`;

export const logQueryTraces = `query queryTraces(${LogTraces.variable}) {${LogTraces.query}}`;

export const queryTraceDetailExist = `query queryBasicTracesMulti(${TraceDetailExist.variable}) {${TraceDetailExist.query}}`;
export const queryInstancesWithTotalCount = `query getServiceInstancesWithTotalCount(${TraceInstances.variable}) {${TraceInstances.query}}`;

export const queryEndpointsWithTotalCount = `query queryEndpoints(${TraceEndpoints.variable}) {${TraceEndpoints.query}}`
